// extracted by mini-css-extract-plugin
export var storyRowWrapperCenter = "x_tM d_bD";
export var storyRowWrapper = "x_hx d_hx d_bK";
export var storyLeftWrapper = "x_tN d_bz d_bP";
export var storyWrapperFull = "x_tP d_cD";
export var storyWrapperFullLeft = "x_pl d_cD d_bz d_bP d_bD";
export var contentWrapper = "x_mS d_hy";
export var storyLeftWrapperCenter = "x_tQ d_hz d_bz d_bD d_bP d_bJ";
export var storyRightWrapperCenter = "x_tR d_hF";
export var storyHeader = "x_tS d_hD d_w d_cs";
export var storyHeaderCenter = "x_hC d_hC d_w d_cs d_dw d_by";
export var storyParagraphCenter = "x_hB d_hB d_by d_dw";
export var storyBtnWrapper = "x_tT d_d2 d_d1 d_w d_bz d_bG";
export var storyBtnWrapperCenter = "x_hJ d_hJ d_d1 d_w d_bz d_bD";
export var imageWrapper = "x_tV d_fg d_Z";
export var imageWrapperFull = "x_tW d_w d_H d_bf d_Z";
export var SubtitleSmall = "x_qd q_qd q_q2 q_rd";
export var SubtitleNormal = "x_qf q_qf q_q2 q_rf";
export var SubtitleLarge = "x_qg q_qg q_q2 q_rg";
export var textLeft = "x_dv";
export var textCenter = "x_dw";
export var textRight = "x_dx";